import { AWPMFWPMNotificationsTranslation } from 'locales/de/pages/AWPM-FWPM/notifications';

const en: AWPMFWPMNotificationsTranslation = {
  info: 'The selection results have been published'
};

export default en;
